import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const Title = styled(Typography)`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.fixed.white};
`;

export const Caption = styled(Typography)`
  text-align: left;
  width: 100%;
  color: ${({ theme }) => theme.palette.fixed.white};
`;
